import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const rejectHandoff = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	reason: string,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('reject_handoff', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyReject')
		return null
	}
	if (!reason.trim()) {
		notify.error('workItem.rejectionReasonRequired')
		return null
	}
	try {
		const updated = await port.rejectHandoff(item.id, ctx.actorId, ctx.actorName, reason.trim())
		notify.success('workItem.rejectedAndReturned')
		return updated
	} catch {
		notify.error('workItem.rejectFailed')
		return null
	}
}

export { rejectHandoff }
